import hdrm from '../../hdrm';
import site from '../../site';

import actionTypes from '../constants/action-types';
import globals from '../../globals';
import { UPDATE_LIVE_ONLY } from '../../hdrm/constants/update-strategies';

const shiftElement = (store) => (next) => (action) => {
  switch (action.type) {
    case actionTypes.SHIFT_ELEMENT: {
      const { elementId, refElementId, position, globalsToUpdate, options } = action.payload;
      const { strategy } = options;

      const newHTML = hdrm.operations.shiftElement(elementId, refElementId, position, strategy);

      if (strategy !== UPDATE_LIVE_ONLY) {
        const state = store.getState();
        const pageId = site.selectors.getActivePageId(state);

        globals.helpers.saveGlobals(globalsToUpdate);
        store.dispatch(site.actions.setPageHTML(pageId, newHTML));
      }

      next(action);

      break;
    }
    default:
      next(action);
  }
};

export default shiftElement;
